var map = {
	"./hh-1.jpg": 8597,
	"./hh-2.jpg": 5018,
	"./hh-3.jpg": 3303,
	"./mc-1.png": 49,
	"./mc-2.png": 9882,
	"./syn2-1.png": 9605,
	"./syn2-2.png": 2254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3084;